module.exports = __webpack_public_path__ + "static/media/leonard-cotte.4581b29e.jpg";